import { render, staticRenderFns } from "./ServiceTypeList.vue?vue&type=template&id=4556369e&"
import script from "./ServiceTypeList.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeList.vue?vue&type=style&index=0&id=4556369e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports